/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

import { DAYS, DAY_ITEMS } from 'cio/utils/delivery-window';
import FALLBACK_TIME_ZONES, { CAMPAIGN_TIME_ZONES, CUSTOMER_TIME_ZONE } from 'cio/utils/time-zones';

const TIME_ITEMS = [
  {
    label: 'any time',
    value: true,
  },
  {
    label: 'specific times…',
    value: false,
  },
];

@tagName('')
export default class Editor extends Component {
  illegalFallbackZoneAttemptedSave = false;
  actionAbstract = null;
  isSaving = false;
  onSelect() {}
  onDeselect() {}
  _allDays = DAYS;
  _dayItems = DAY_ITEMS;
  _timeItems = TIME_ITEMS;
  get _timeZones() {
    if (this.actionAbstract?.action?.campaign?.isDataCampaign) {
      return FALLBACK_TIME_ZONES;
    }
    return CAMPAIGN_TIME_ZONES;
  }
  _customerTimeZone = CUSTOMER_TIME_ZONE;
  _fallbackTimeZones = [{ label: 'Choose one', value: '', disabled: true }].concat(FALLBACK_TIME_ZONES);

  @action
  setConditions(conditions) {
    this.set('actionAbstract.preconditions', conditions);
  }

  @action
  onStartTimeChange(value) {
    this.set('actionAbstract.startTime', value);
  }

  @action
  onEndTimeChange(value) {
    this.set('actionAbstract.endTime', value);
  }
}
